<template>
  <div>
    <Container>
      <div class="container heading text-left text-md-center">
        <h1 class="title" v-text="vlog.title"></h1>
        <div class="date">
          <span v-text="vlog.disp_date"></span>
          <span class="mx-1">&bull;</span>
          <span>By {{ app_name() }}</span>
        </div>
      </div>
      <Share :tags="seoTagsToArr(vlog.seo_tags) || []" />
      <div>
        <iframe
          :src="vlog.external_url"
          :alt="vlog.title"
          :title="vlog.title"
          class="img-fluid"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      </div>
    </Container>
    <Featured
      :excluedIds="[vlog.id]"
      v-if="vlog && vlog.id"
      title="Related Vlogs"
      :description="null"
    />
    <Container>
      <hr class="mb-4 mt-0" />
      <SocialLinks class="mt-4" />
    </Container>
    <VlogPlayer />
  </div>
</template>
<script>
import Share from "../shared/share.vue";
import Featured from "./featured.vue";
import VlogPlayer from "../shared/vlogPlayer.vue";

export default {
  components: {
    SocialLinks: () =>
      import(
        /* webpackChunkName: "home-shared-social-links" */ "../shared/socialLinks"
      ),
    Share,
    Featured,
    VlogPlayer,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    vlog() {
      return this.data.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.heading {
  margin-top: 1.2rem;
  margin-bottom: 2rem;
  color: var(--dark);
  .title {
    font-size: 2.6rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  .date {
    font-size: 1rem;
    opacity: 0.7;
  }
}
iframe {
  width: 100%;
  height: max(800px, 60vh);
  object-fit: cover;
  max-height: max(800px, 60vh);
  box-shadow: var(--box-shadow);
  border-radius: var(--border-radius);
  border: 0;
}

@media (max-width: 768px) {
  .heading .title {
    font-size: 2.2rem;
  }
  iframe {
    height: max(600px, 60vh);
    max-height: max(600px, 60vh);
  }
}

@media (max-width: 576px) {
  .heading .title {
    font-size: 1.8rem;
  }
  iframe {
    height: 520px;
  }
}
</style>